module.exports = __webpack_public_path__ + "img/copaAmerica216.3867f51c.jpg";